var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBold = function SvgBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.74 12h7.51a4 4 0 0 0 4-4v-.25a4 4 0 0 0-4-4H6.74a1 1 0 0 0-1 1V12Zm0 0v7.25a1 1 0 0 0 1 1h5.76m.5 0h1.25a4 4 0 0 0 4-4V16a4 4 0 0 0-4-4H13"
  })));
};
export default SvgBold;